import { categories } from '../data';

export default function Footer() {
  const quick = [
    { label: '今日热榜', href: '#hot' },
    { label: '分类导航', href: '#category' },
    { label: '精品专题', href: '#topic' },
    { label: '常设栏目', href: '#column' },
    { label: '话题标签', href: '#tags' },
    { label: '最新动态', href: '#update' },
  ];
  const guide = [
    { label: '常见问题', href: '#faq' },
    { label: '关于本站', href: '#contact' },
    { label: '收录建议', href: '#contact' },
  ];
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-emotion-happy-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-background-50">导航吃瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              一个面向吃瓜爱好者的内容话题索引门户。按分类、标签、专题、板块、栏目与目录整理娱乐热点，让你不再大海捞针，快速定位自己感兴趣的吃瓜方向，理性围观、脉络清晰。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {categories.slice(0, 6).map((c) => (
                <a
                  key={c.id}
                  href="#category"
                  onClick={() => document.getElementById(`cat-${c.id}`)?.scrollIntoView({ behavior: 'smooth' })}
                  className="whitespace-nowrap rounded-full bg-background-800 px-3 py-1.5 text-xs text-background-300 transition hover:bg-background-700 hover:text-background-50"
                >
                  {c.name}
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quick.map((q) => (
                <li key={q.label}>
                  <a href={q.href} className="text-sm text-background-300 transition hover:text-background-50">{q.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="帮助链接">
            <h3 className="text-sm font-bold text-background-50">帮助与反馈</h3>
            <ul className="mt-4 space-y-2.5">
              {guide.map((g) => (
                <li key={g.label}>
                  <a href={g.href} className="text-sm text-background-300 transition hover:text-background-50">{g.label}</a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-background-400">合作与建议</p>
            <a href="mailto:hello@navichigua.example" className="text-sm text-background-300 underline decoration-background-600 underline-offset-4 transition hover:text-background-50">
              hello@navichigua.example
            </a>
          </nav>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 导航吃瓜 · 整理分类 · 标签 · 专题 · 板块 · 栏目 · 目录索引</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="inline-flex items-center gap-1.5"><i className="ri-leaf-line text-accent-400" aria-hidden="true"></i>理性围观</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-loop-left-line text-primary-400" aria-hidden="true"></i>持续更新</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-focus-3-line text-secondary-400" aria-hidden="true"></i>脉络清晰</span>
          </div>
        </div>
      </div>
    </footer>
  );
}